import axios from '@/lib/axios';
import { FixedAsset, Product } from '@/hooks/api/models';
import { useMutation } from '@tanstack/react-query';

/**
 * 2290. 次回契約プラン更新（初回の場合は現在契約更新）
 * [PUT] /workspaces/:identifier/next_contract_plan
 */
type Props = {
  identifier: string;
  plan_id: number;
};
const updateNextPlan = (props: Props): Promise<any> => {
  return axios.put(`/api/workspaces/${props.identifier}/next_contract_plan`, props);
};

export const useUpdateNextPlan = () => {
  return useMutation({
    mutationFn: updateNextPlan,
  });
};
